import type { FeatureRoute } from '../types';
import { AccountingPage } from './accounting/AccountingPage';
import { AccountLedgerPage } from './accounting/AccountLedgerPage';
import { JournalEntryPage } from './accounting/JournalEntryPage';
import { AuditPage } from './audit/AuditPage';
import { NotificationsPage } from './reminders/NotificationsPage';
import { RemindersPage } from './reminders/RemindersPage';
import { ReportPage } from './reports/ReportPage';
import { ReportsHub } from './reports/ReportsHub';
import { SyncPage } from './sync/SyncPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'reports', element: <ReportsHub /> },
  { path: 'reports/:slug', element: <ReportPage /> },
  { path: 'accounting', element: <AccountingPage /> },
  { path: 'accounting/accounts/:id', element: <AccountLedgerPage /> },
  { path: 'accounting/journal/:id', element: <JournalEntryPage /> },
  { path: 'reminders', element: <RemindersPage /> },
  { path: 'notifications', element: <NotificationsPage /> },
  { path: 'audit', element: <AuditPage /> },
  { path: 'sync', element: <SyncPage /> },
];
